<template>
  <app-layout>
    <div class="gift-container">
      <div id="overlay" v-if="overlay"></div>
      <div class="gifts-form-page container">
        <v-form @submit="(e) => e.preventDefault()" v-model="formValid" ref="form" class="w-full" lazy-validation>
          <div class="flex flex-col xl:flex-row">
            <div class="main-form flex-grow">
              <app-box-header
                :title="$t('gifts.your_personal_info')"
                class="personal-info"
              >
                <div class="md:flex">
                  <div class="w-full md:w-1/2 md:mr-2 mb-2">
                    <label for="name" class="font-bold">{{ $t('form.name') }}*</label>
                    <v-text-field
                      id="name"
                      v-model="personalData.name"
                      :rules="[(v) => !!v || $t('form.enter_name')]"
                      height="45"
                      class="avm-text-field"
                      outlined
                      dense
                      solo
                      flat
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </div>
                  <div class="w-full md:w-1/2 md:ml-2 mb-2">
                    <label for="lastName" class="font-bold">{{ $t('form.last_name') }}*</label>
                    <v-text-field
                      id="lastName"
                      v-model="personalData.lastName"
                      :rules="[(v) => !!v || $t('form.enter_last_name')]"
                      height="45"
                      class="avm-text-field"
                      outlined
                      dense
                      solo
                      flat
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </div>
                </div>
                <label for="lastName" class="font-bold">{{ $t('form.email') }}*</label>
                <v-text-field
                  id="email"
                  v-model="personalData.email"
                  :rules="emailRules"
                  height="45"
                  class="avm-text-field"
                  outlined
                  dense
                  solo
                  flat
                  required
                  hide-details="auto"
                ></v-text-field>
              </app-box-header>
              <!-- Comments -->
              <!-- <app-box-header
                title="Comentarios"
                class="comments"
              >
                <v-textarea
                name="comments"
                v-model="personalData.comments"
                outlined
                solo
                flat
                rows="3"
                ></v-textarea>
              </app-box-header> -->
              <!-- Payment Box -->
              <payment-methods-component
                ref="paymentMethods"
                gift
              ></payment-methods-component>
              <!-------------->
              <terms-component></terms-component>
              <!-- Comfirm button -->
              <comfirmation-component
                @submit-step="submitStep"
                @show-overlay-to-false="showOverlayToFalse"
                @show-paypal-to-false="showPaypalToFalse"
                @paypal-approved="scrollToBottom"
                :showPaypal="showPaypal"
                :showOverlay="showOverlay"
                gift
              ></comfirmation-component>
              <!-------------------->
            </div>
            <div class="resume-form">
              <h3 class="mb-4">{{$t("shared.booking_summary")}}</h3>
              <hr />
              <div class="my-4">
                <div class="flex items-center">
                  <img
                    class="mr-2"
                    src="/img/icons/airplane.svg"
                    alt="Origen"
                  />
                  <p>{{ ucfirst($t('shared.from')) }} {{ origin.name }}</p>
                </div>
                <div class="flex items-center mt-2">
                  <img class="mr-2" src="/img/icons/user.svg" alt="Pasajeros" />
                  <p>
                    {{ passengers }} {{ $tc('shared.adult', passengers) }}
                  </p>
                </div>
                <div class="flex items-center mt-2">
                  <img
                    class="mr-2"
                    src="/img/icons/location.svg"
                    alt="Destino"
                  />
                  <p>{{ $t('shared.destiny') }} {{ destination.name }}</p>
                </div>
              </div>
              <hr />
              <div class="passenger-price flex justify-between mt-4">
                <p>{{$t("shared.price_passenger")}}:</p>
                <p>&nbsp;{{ travellerPrice | currency }}</p>
              </div>
              <div class="flex justify-between mt-3">
                <h4>{{ $t('shared.total') }}:</h4>
                <p class="gift-price">&nbsp;{{ totalprice | currency }}</p>
              </div>
            </div>
            <app-fixed-booking-summary
              ref="fixed-booking-summary"
              class="xl:hidden"
              :date="null"
              :origin="origin.name"
              :destiny="destination.name"
              :travellersTotal="passengers"
              :travellerPrice="travellerPrice"
              :fixedTotalPrice="true"
              :totalPrice="totalprice"
              :expansionPanelHeight="370"
              @stepComplete="submitStep"
            ></app-fixed-booking-summary>
          </div>
        </v-form>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";
import {
  GIFTS_GET_SELECTED_ORIGIN,
  GIFTS_GET_SELECTED_DESTINATION,
  GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE,
  GIFTS_GET_SELECTED_DESTINATION_FINAL_PRICE,
} from "../../store/gifts/getter-types";
import * as STEPPER_ACTIONS from "../../store/stepper/action-types";
import { GET_PAYMENT_METHOD } from "../../store/getter-types";
import { SET_TERMS } from "../../store/booking/mutation-types";
import { GET_TERMS } from "../../store/booking/getter-types";
import { ucfirst } from '../../utils/strings';

export default {
  data() {
    return {
      overlay: false,
      drawer: null,
      formValid: false,
      formHasErrors: false,
      personalData: { ...this.$store.state.gifts.personalData },
      // paymentMethod: this.$store.state.gifts.paymentMethod,
      privacy: false,
      showPaypal: false,
      showOverlay: false,
      emailRules: [
        v => !!v || this.$t('form.enter_email'),
        v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+\s*$/.test(v) || this.$t('form.invalid_email')
      ],
      ucfirst,
    };
  },

  computed: {
    travellerPrice() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE];
    },
    totalprice() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION_FINAL_PRICE];
    },
    origin() {
      return this.$store.getters[GIFTS_GET_SELECTED_ORIGIN];
    },
    destination() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION];
    },
    passengers() {
      return this.$store.state.gifts.passengers;
    },
    paymentMethod() {
      return this.$store.getters[GET_PAYMENT_METHOD];
    },
    terms() {
      return this.$store.getters[GET_TERMS].terms;
    },
  },

  methods: {
    showPaypalToFalse() {
      this.showPaypal = false;
    },
    showOverlayToFalse() {
      this.showOverlay = false;
    },
    handleOverlayUpdate(value) {
      this.overlay = value;
    },
    scrollToBottom() {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        window.scrollTo(0, 9999);
      }
    },
    setTermsError() {
      this.$store.commit(SET_TERMS, {
        ...this.$store.getters[GET_TERMS],
        terms: {
          error: !this.terms.value,
          value: this.terms.value,
        },
      });
    },
    submitStep() {
      this.$refs.form.validate();
      this.setTermsError();

      if (this.$refs['fixed-booking-summary'].isOpen) {
        this.$refs['fixed-booking-summary'].toogleExpansionPanel();
      }

      if (!this.formValid) {
        this.$toastr.e(window.i18n.t('toast.error_5'));
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
        return;
      } else if (this.$store.getters[GET_TERMS].terms.error) {
        this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, false);
        return;
      }

      this.$store.dispatch(STEPPER_ACTIONS.SET_STEPPER_LOADING, true);
      if (this.paymentMethod == "paypal") {
        this.showPaypal = true;
        this.showOverlay = true;
        const paypalContainer = document.getElementById("submitContainer");
        window.scrollTo({
          top: paypalContainer.offsetTop,
          left: 0,
          behavior: "smooth",
        });
      } else {
        this.retrievePaymentParameters();
      }
    },
    retrievePaymentParameters() {
      this.$refs.paymentMethods.$refs.redsysComponent.retrievePaymentParameters();
    },
    submitStripeForm(){
      const stripe_button = document.getElementById("submit-stripe");
      console.log(stripe_button);
      stripe_button.click();
    },
  },

  watch: {
    personalData: {
      deep: true,
      handler(personalData) {
        this.$store.commit(SET_GIFTS_STATE, {
          prop: "personalData",
          value: { ...personalData },
        });
      },
    },
  },

  beforeRouteEnter(to, from, next) {
    return from.name === "gifts-destination-details"
      ? next()
      : next({ path: "/" });
  },

  created() {
    this.$eventHub.$on("update-overlay", this.handleOverlayUpdate);
  },
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.error--text {
  color: #b71c1c !important;
}
.fixed-booking-summary-gifts {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: $white;
  padding: 1.2rem 0.8rem;
  box-shadow: 0 -2px 13px -3px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  .details-btn {
    color: #00adbc;
    font-weight: 700;
    font-size: 13px;
    text-transform: unset !important;
  }
  .v-card__price {
    font-size: 15px;
    font-weight: 700;
  }
  h3 {
    font-size: 16.7px;
    font-weight: 700;
  }
  @media screen and (max-width: $breakpoint-landing-tablet) {
    padding-bottom: 10px;
    margin-left: 0 !important;
  }
  .collapsable-section {
    bottom: 88px;
    z-index: 8;
    box-shadow: none !important;
    height: unset !important;
    margin: 0px !important;

    .v-navigation-drawer__content {
      margin: 0px !important;
      @media screen and (max-width: $breakpoint-landing-tablet) {
        width: 100% !important;
        margin: 0px !important;
        .booking-summary {
          padding: 0;
          border: none;
        }
      }
    }
  }
  .sticky-section {
    z-index: 10;
    .grid {
      .v-card__price {
        font-family: $avenirHeavy;
        padding-left: 16px;
      }
    }
  }
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1001; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.v-input.avm-text-field .v-input__slot {
  margin-bottom: 0.1rem;
}
.v-input--selection-controls__input .v-icon {
  color: #00adbc !important;
  caret-color: #00adbc !important;
}
.gift-container {
  .payment-container {
    &.mt-6 {
      margin-top: 24px !important;
    }
    @media (min-width: 1024px) {
      &.xl\:mt-0 {
        margin-top: 0 !important;
      }
    }
    .payment-method-item {
      cursor: pointer;
      .img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
      }
      p {
        font-family: $avenirHeavy;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .radio-group {
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start;
    justify-content: flex-start;
    label {
      font-size: 14px;
      line-height: 19px;
    }
    > label {
      font-family: $avenirHeavy;
      margin-right: 40px;
      margin-top: 7px;
    }
    .v-radio {
      @media (min-width: 1024px) {
        margin-right: 25px;
      }
    }
    .v-input {
      margin-top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .v-input__control {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .v-input__slot {
          margin: 0;
        }
      }
    }
  }
  .overlay-paypal {
    width: 100%;
    height: 65px;
    position: absolute;
    z-index: 1000;
    background-color: rgba($color: #f1f2f8, $alpha: 0.5);
    @media (min-width: 400px) {
      width: 250px;
    }
  }
  .terms-container,
  .submit-container {
    margin-top: 48px;
    display: flex;
    justify-content: center;
  }
  .v-input--radio-group--row .v-input--radio-group__input {
    flex-wrap: wrap;
    @media (min-width: 1024px) {
      flex-wrap: unset !important;
    }
  }
}
</style>
